import { render, staticRenderFns } from "./TimelineComponent.vue?vue&type=template&id=ddf05e88&scoped=true"
import script from "./TimelineComponent.vue?vue&type=script&lang=js"
export * from "./TimelineComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf05e88",
  null
  
)

export default component.exports